import { Component } from 'opus-angular-seed-core';
import template from './template.html';

@Component({
    bindings: {
        form: '=',
        disabled: '=',
        models: '=',
        question: '=',
        chosenFiles: '=',
        chosenVideoFiles: '='
    },
    template
})

export default class {
    constructor ($scope, $translate,
                 TokenService, QuestionService, FormService, ModalService, CkEditorService,
                 QUESTIONS_TYPE_ENUM, QUESTIONS_ANSWER_CORRECTNESS_TYPE_ENUM,
                 QUESTIONS_VIDEO_TYPE_ENUM) {
        this.$scope = $scope;
        this.$translate = $translate;
        this.QuestionService = QuestionService;
        this.FormService = FormService;
        this.ModalService = ModalService;
        this.CkEditorService = CkEditorService;
        this.QUESTIONS_TYPE_ENUM = QUESTIONS_TYPE_ENUM;
        this.QUESTIONS_ANSWER_CORRECTNESS_TYPE_ENUM = QUESTIONS_ANSWER_CORRECTNESS_TYPE_ENUM;
        this.defaultLanguage = (
            (TokenService.getCompanyLanguage && TokenService.getCompanyLanguage()) || ''
        ).toString().toUpperCase();
        this.QUESTIONS_VIDEO_TYPE_ENUM = QUESTIONS_VIDEO_TYPE_ENUM;
        this.down = false;
    }

    $onInit () {
        this.maxVideoFileSizeInMB = 500;
        if (!this.form.errors.questionAnswers) {
            this.form.errors.questionAnswers = [];
        }
        this.ckconfig = this.CkEditorService.getDefaultConfig();
        this.ckconfig.readOnly = this.disabled;
        this.ensureTranslationsForAllAnswers();
        this.initVideoTypeValue();
        this.initCorrectness();
        this.$scope.$evalAsync(() => this.syncAll());
        this.$scope.$watch(
            () => (this.models && this.models.list && this.models.list.length) || 0,
            (n, o) => {
                if (n !== o) this.syncAll();
            }
        );
        this.$scope.$watch(
            () => (this.form && this.form.model && this.form.model.questionAnswers
                ? this.form.model.questionAnswers.length : 0),
            (n, o) => {
                if (n !== o) this.syncAll();
            }
        );
        this.$scope.$watchCollection(
            'vm.form.model.questionAnswers',
            (arr) => {
                const K = this.QUESTIONS_ANSWER_CORRECTNESS_TYPE_ENUM.KEYS;
                arr = arr || [];
                for (let i = 0; i < arr.length; i++) {
                    const a = arr[i];
                    if (!a) continue;
                    if (a.correctness === undefined || a.correctness === null || a.correctness === '') {
                        a.correctness = K.INCORRECT;
                        a.isCorrect = K.INCORRECT;
                        a.isNotApplicable = '';
                        a.points = '';
                    }
                    this.syncAnswerAt(i);
                }
            }
        );
    }

    initCorrectness () {
        const K = this.QUESTIONS_ANSWER_CORRECTNESS_TYPE_ENUM.KEYS;
        (this.form.model.questionAnswers || []).forEach((answer, idx) => {
            if (answer.correctness === K.CORRECT) {
                answer.isCorrect = K.CORRECT;
                answer.isNotApplicable = '';
                answer.correctness = K.CORRECT;
            }
            else if (answer.correctness === K.NOT_APPLICABLE) {
                answer.isNotApplicable = K.NOT_APPLICABLE;
                answer.isCorrect = K.INCORRECT;
                answer.points = '';
                answer.correctness = K.NOT_APPLICABLE;
            }
            else {
                answer.isCorrect = K.INCORRECT;
                answer.isNotApplicable = '';
                answer.points = '';
                answer.correctness = K.INCORRECT;
            }
            this.syncAnswerAt(idx);
        });
    }

    syncAll () {
        (this.form.model.questionAnswers || []).forEach((_, i) => this.syncAnswerAt(i));
    }

    removeItem (key) {
        if (this.models.list.length > 1) {
            this.models.list.splice(key, 1);
            this.form.model.questionAnswers.splice(key, 1);
            this.chosenVideoFiles[key] = null;
        }
    }

    dragStart (index) {
        this.dragStartIndex = index;
    }

    dropCallback (index) {
        this.dragEndIndex = index;

        if (this.dragStartIndex < this.dragEndIndex) {
            this.dragEndIndex -= 1;
        }

        if (this.dragStartIndex !== this.dragEndIndex) {
            this.switchAnswers();
        }
    }

    addItem () {
        this.models.list.push({});
    }

    addNewAnswer () {
        const defaultAnswer = this.QuestionService.addItem(this.models);
        const idx = this.form.model.questionAnswers.length;
        this.form.model.questionAnswers[idx] = defaultAnswer;

        const lang = this.defaultLanguage; // UPPERCASE
        if (!this.form.model.questionAnswers[idx].translations[lang]) {
            this.form.model.questionAnswers[idx].translations[lang] = {};
        }
        const t = this.form.model.questionAnswers[idx].translations[lang];
        if (typeof t.text === 'undefined') t.text = '';
        if (typeof t.feedback === 'undefined') t.feedback = '';

        if (!this.form.model.questionAnswers[idx].correctness) {
            const K = this.QUESTIONS_ANSWER_CORRECTNESS_TYPE_ENUM.KEYS;
            this.form.model.questionAnswers[idx].correctness = K.INCORRECT;
            this.form.model.questionAnswers[idx].isCorrect = K.INCORRECT;
            this.form.model.questionAnswers[idx].isNotApplicable = '';
        }
        this.syncAnswerAt(idx);
    }

    switchAnswers () {
        const from = this.dragStartIndex;
        const to = this.dragEndIndex;
        const total = this.form.model.questionAnswers.length;

        this.moveByIndex(this.form.model.questionAnswers, from, to, total);
        this.moveByIndex(this.question && this.question.questionAnswers, from, to, total);
        this.moveByIndex(this.form.errors && this.form.errors.questionAnswers, from, to, total);
        this.moveByIndex(this.chosenFiles, from, to, total);
        this.moveByIndex(this.chosenVideoFiles, from, to, total);

        this.syncAll();
    }

    moveByIndex (collection, from, to, length) {
        if (!Array.isArray(collection)) {
            return;
        }

        while (collection.length < length) {
            collection.push(undefined);
        }

        const [moved] = collection.splice(from, 1);
        collection.splice(to, 0, moved);
    }

    showImageBlock () {
        return !this.FormService.hasNonCertForms(this.form.model.forms);
    }

    setFile (file, key) {
        this.chosenFiles[key] = file.name;
        this.form.model.questionAnswers[key].removeImage = false;
        this.form.model.questionAnswers[key].imageFile = file;
    }

    isMaxVideoFileSizeExceeded (fileSize) {
        return fileSize > this.maxVideoFileSizeInMB * 1000000;
    }

    validateVideoFileSize (fileSize, key) {
        if (this.isMaxVideoFileSizeExceeded(fileSize)) {
            this.form.errors.questionAnswers[key] = {
                videoFile: this.$translate.instant('question.Inserted video must not be larger than {fileSize}Mb', {
                    fileSize: this.maxVideoFileSizeInMB
                })
            };
        }
        else {
            delete this.form.errors.questionAnswers[key];
            this.form.errors.questionAnswers = this.form.errors.questionAnswers.flat();
        }
    }

    setVideoFile (file, key) {
        if (!file) {
            return;
        }

        this.validateVideoFileSize(file.size, key);
        this.chosenVideoFiles[key] = file.name;
        this.form.model.questionAnswers[key].removeVideo = false;
        this.form.model.questionAnswers[key].videoFile = file;
    }

    confirmRemoveImage (key) {
        const msg = this.$translate.instant('questionAnswer.Remove image?');
        this.ModalService.confirm(msg, 'small').then(() => {
            this.form.model.questionAnswers[key].removeImage = true;
            this.$scope.$parent.vm.save();
        });
    }

    confirmRemoveVideo (key) {
        const msg = this.$translate.instant('questionAnswer.Are you sure you wish to delete the video?');
        this.ModalService.confirm(msg, 'small').then(() => {
            this.form.model.questionAnswers[key].removeVideo = true;
            this.chosenVideoFiles[key] = null;
            this.$scope.$parent.vm.save();
        });
    }

    initVideoTypeValue () {
        this.form.model.questionAnswers.forEach(answer => {
            if (answer.videoType) {
                return;
            }

            if (answer.videoFilename) {
                answer.videoType = this.QUESTIONS_VIDEO_TYPE_ENUM.KEYS.FILE;
            }
            else {
                answer.videoType = this.QUESTIONS_VIDEO_TYPE_ENUM.KEYS.URL;
            }
        });
    }

    toggleVideoType (key) {
        if (this.form.model.questionAnswers[key].videoType === this.QUESTIONS_VIDEO_TYPE_ENUM.KEYS.FILE) {
            this.form.model.questionAnswers[key].videoUrl = null;
        }
        else if (this.form.model.questionAnswers[key].videoType === this.QUESTIONS_VIDEO_TYPE_ENUM.KEYS.URL) {
            this.form.model.questionAnswers[key].removeVideo = true;
            this.form.model.questionAnswers[key].videoFile = null;
            this.chosenVideoFiles[key] = null;
            delete this.form.errors.questionAnswers[key];
            this.form.errors.questionAnswers = this.form.errors.questionAnswers.flat();
        }
    }

    toggleNotApplicable (key) {
        if (this.form.model.questionAnswers[key].isNotApplicable === this.QUESTIONS_ANSWER_CORRECTNESS_TYPE_ENUM.KEYS.NOT_APPLICABLE) {
            this.form.model.questionAnswers[key].correctness = this.QUESTIONS_ANSWER_CORRECTNESS_TYPE_ENUM.KEYS.NOT_APPLICABLE;
            this.form.model.questionAnswers[key].points = '';
        }
        else {
            this.form.model.questionAnswers[key].correctness = this.form.model.questionAnswers[key].isCorrect || this.QUESTIONS_ANSWER_CORRECTNESS_TYPE_ENUM.KEYS.INCORRECT;
        }
        this.syncAnswerAt(key);
    }

    toggleIsCorrect (key) {
        this.form.model.questionAnswers[key].correctness = this.form.model.questionAnswers[key].isCorrect;

        if (this.form.model.questionAnswers[key].isCorrect !== this.QUESTIONS_ANSWER_CORRECTNESS_TYPE_ENUM.KEYS.CORRECT) {
            this.form.model.questionAnswers[key].points = '';
        }
        this.syncAnswerAt(key);
    }

    ensureTranslationsForAllAnswers () {
        const lang = this.defaultLanguage;
        (this.form.model.questionAnswers || []).forEach(a => {
            if (!a.translations) a.translations = {};
            if (!a.translations[lang]) a.translations[lang] = {};
            if (typeof a.translations[lang].text === 'undefined') a.translations[lang].text = '';
            if (typeof a.translations[lang].feedback === 'undefined') a.translations[lang].feedback = '';
        });
    }

    syncAnswerAt (index) {
        const qa = this.form.model.questionAnswers[index];
        if (!this.models || !this.models.list || !qa) return;
        if (!this.models.list[index]) this.models.list[index] = {};
        this.models.list[index].correctness = qa.correctness;
        this.models.list[index].isCorrect = qa.isCorrect;
        this.models.list[index].isNotApplicable = qa.isNotApplicable;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/questions/actions/answers/radioType/index.js